import { db } from './firebase';
import { doc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore'; // Added serverTimestamp

// ✅ SAVE LESSON PROGRESS FUNCTION (unchanged)
export const saveLessonProgress = async (userId, lessonId, progressData) => {
  try {
    await setDoc(
      doc(db, 'users', userId, 'lessons', lessonId),
      progressData,
      { merge: true }
    );

    await updateDoc(doc(db, 'users', userId), {
      [`lessons.${lessonId}`]: true
    });

    console.log(`✅ Saved progress and marked ${lessonId} as complete.`);
  } catch (error) {
    console.error('❌ Error saving progress:', error);
  }
};



// ✅ SAVE STUDENT WRITING FUNCTION (AI Draft + Final Feedback + Status)
export const saveStudentWriting = async (userId, lessonId, writingText, aiDraftFeedback = '') => {
  console.log("📝 [saveStudentWriting] userId:", userId);
  console.log("📝 [saveStudentWriting] lessonId:", lessonId);
  console.log("📝 [saveStudentWriting] writingText:", writingText);
  console.log("📝 [saveStudentWriting] aiDraftFeedback:", aiDraftFeedback);

  try {
    const writingRef = doc(db, 'users', userId, 'writings', lessonId);

    await setDoc(writingRef, {
      lessonId: lessonId,
      writingText: writingText,
      aiDraftFeedback: aiDraftFeedback,  // ✅ Save AI draft for teachers
      submittedAt: new Date()
    }, { merge: true });

    console.log(`✅ Writing and AI draft feedback saved for lesson ${lessonId}`);
  } catch (error) {
    console.error("❌ Error saving writing:", error);
  }
};




// ✅ TEACHER SAVES FINAL FEEDBACK (new!)
export const saveTeacherFinalFeedback = async (userId, lessonId, finalFeedback) => {
  console.log("🎓 [saveTeacherFinalFeedback] userId:", userId);
  console.log("🎓 [saveTeacherFinalFeedback] lessonId:", lessonId);
  console.log("🎓 [saveTeacherFinalFeedback] finalFeedback:", finalFeedback);

  try {
    const writingRef = doc(db, 'users', userId, 'writings', lessonId);

    await updateDoc(writingRef, {
      finalFeedback: finalFeedback,
      feedbackStatus: 'ready',         // ✅ Marks it ready for student view
      updatedAt: serverTimestamp()     // ✅ Optional: track when feedback is posted
    });

    console.log(`✅ Final feedback saved successfully for lesson ${lessonId}`);
  } catch (error) {
    console.error("❌ Error saving teacher final feedback:", error);
  }
};



// ✅ GENERATE MOCK FEEDBACK FUNCTION (unchanged)
export const generateMockFeedback = (writingText) => {
  const feedbackTemplates = [
    "Great job! Your essay is well-structured. Focus on expanding your ideas for higher scores.",
    "Good vocabulary! Try to add more linking words for better coherence.",
    "Your grammar is strong. Pay attention to sentence variety.",
    "You have a clear argument. Next time, support it with more examples.",
    "Watch your punctuation. A few sentences could be clearer with commas or periods."
  ];

  const randomIndex = Math.floor(Math.random() * feedbackTemplates.length);
  return feedbackTemplates[randomIndex];
};

